module.exports = __webpack_public_path__ + "statics/img/it.6addcb95.jpg";